import React, { Component } from 'react';
import TitleComponent from '../Components/TitleComponent';

import { withStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';

import UiCore from '../Components/UiCore';
import MFAUserSettings from '../Components/MFA/MFAUserSettings';

const styles = theme => ({
  contentContainer: {
    background: theme.palette.background.paper,
    padding: theme.spacing(3),
    [theme.breakpoints.down('xs')]: {
      padding: theme.spacing(2),
    },
    height: "100%",
  },
});

class AccountSecurity extends Component {
  constructor(props) {
    super(props);

    this.state = {
      ApiError: null,
    };
  }

  handleApiError = ApiError => {
    this.setState({ ApiError });
    if (ApiError) {
      setTimeout(() => this.handleApiError(null), 1);
    }
  }

  render() {
    const { ApiError } = this.state;
    const { classes } = this.props;

    const content = (
      <Container maxWidth="sm" className={classes.contentContainer}>
        <TitleComponent title="Account Security" />
        <MFAUserSettings />
      </Container>
    );

    return (
      <UiCore title="Account Security"
        apiError={ApiError}
        hideProjectName
        content={content}
      />
    );
  }
}

export default withStyles(styles, { withTheme: true })(AccountSecurity);
